export default {
  cloudinary: {
    apiKey: "285515992178477",
    cloudName: "dlhqhul0b",
    uploadPreset: "visitmuseo"
  }
};
